/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticleHeader from 'sites/allas/components/standalone/ArticleHeader';

export const DynamicStandaloneArticleHeader = StandaloneArticleHeader;
export type DynamicStandaloneArticleHeaderProps = PropsFromComponent<typeof StandaloneArticleHeader>;

export const DynamicStandaloneArticleHeaderWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticleHeader => {
    return function DynamicStandaloneArticleHeader(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleHeader');
        return <StandaloneArticleHeader {...mergeProps({ options: { theme } }, props)} />;
    }
}